<template>
  <div v-if="resolved" class="doc-block">
    <h5 v-if="resolved.title" class="doc-block__title mt-4">{{ resolved.title }}</h5>
    <template v-for="(item, index) in resolved.body">
      <p v-if="item.p" :key="index"><doc-text :text="item.p" /></p>
      <ul v-else-if="item.ul" :key="index">
        <li v-for="(line, lineIndex) in item.ul" :key="lineIndex"><doc-text :text="line" /></li>
      </ul>
      <component
        :is="dynamicComponents[item.dynamic]"
        v-else-if="item.dynamic && dynamicComponents[item.dynamic]"
        :key="index"
        :context="context"
      />
    </template>
  </div>
</template>

<script>
import { getBlock } from '@/docs'
import DocText from '@/components/Docs/DocText'
import DocEventTypesTable from '@/components/Docs/DocEventTypesTable'

// Dynamic body items ({ dynamic: 'name' }) are rendered by the components registered here.
const DYNAMIC_COMPONENTS = {
  'event-types-table': DocEventTypesTable
}

// One reusable doc block. Pass either `id` (a block from src/docs/blocks) or a `block` object.
export default {
  name: 'DocBlock',
  components: { DocText },
  props: {
    id: { type: String, default: null },
    block: { type: Object, default: null },
    // Data for dynamic items, e.g. { eventTypes }
    context: { type: Object, default: () => ({}) }
  },
  computed: {
    resolved() {
      return this.block || (this.id ? getBlock(this.id) : null)
    },
    dynamicComponents() {
      return DYNAMIC_COMPONENTS
    }
  }
}
</script>

<style>
.doc-block__title {
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/Docs/DocBlock.vue